import { DndContext, closestCorners, PointerSensor, useSensors, useSensor } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";

export const ReorderingWrapper = ({ sortingArray, handleDragEndTable, handleDragStart, children }) => {
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 5,
            },
        }))

    return (
        <DndContext onDragStart={event => handleDragStart(event)} sensors={ sensors } onDragEnd={ event => handleDragEndTable(event) } collisionDetection={ closestCorners }>
            <SortableContext items={ sortingArray } strategy={ verticalListSortingStrategy }>
                { children }
            </SortableContext>
        </DndContext>
    )
}